const COLLECTION = {
  ADMIN: "Admins",
  MASTER: "Master",
  ADMIN_SESSION: "AdminSession",
  PUSERS: "Pusers",
  PPODS: "Ppods",
  PUSER_SESSION: "Pusersession",
  PTRANSACTIONS: "Ptransactions",
  PTRANSACTIONS: "Ptransactions",
  VISITOR_SESSIONS: "visitor_sessions",
  GUARDS: "Guards",
  GUARD_SESSION: "GuardSession",
};

const COLLECTION_COUNTER = {
  MASTER: "Master",
  PPODS: "PpodsCounter",
  PUSERS: "PuserCounter",
};

const SESSION = {
  ADMIN_SESSION_ID: "adminSessionId",
  PUSER_SESSION_ID: "puserSessionId",
  GUARD_SESSION_ID: "guardSessionId",
};

export { COLLECTION, COLLECTION_COUNTER, SESSION };
